<template>
  <div id="my-invest">
    <v-container>
      <div v-if="this.currentTab === 'homeInvest'">
        <home-invest :country="'Europe'" />
      </div>
      <div v-else>
        <div v-if="this.is_active === '1' && this.passed === 'pass'">
          <div style="color: red">
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs4>
                  <v-card>
                    <div class="zone">
                      <div class="main-title">基金产品</div>
                      <div class="bottom text-xs-center sub-title">¥ {{ fundSum }}</div>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs4>
                  <v-card>
                    <div class="zone" @click="changeTab('homeInvest')" style="cursor: pointer;">
                      <div class="main-title">房产投资</div>
                      <div class="bottom text-xs-center sub-title">查看更多</div>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs4>
                  <v-card>
                    <a href="http://www.canaan-overseas.com">
                      <div class="zone">
                        <div class="main-title">旅游项目</div>
                        <div class="bottom text-xs-center sub-title">查看更多</div>
                      </div>
                    </a>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card>
                    <div class="zone" v-if="fundAccounce.data">
                      <div class="main-title">基金公告</div>
                      <div class="bottom" v-html="fundAccounce.data[0].content"></div>
                    </div>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <v-card>
                    <div class="zone" v-if="homeAccounce.data">
                      <div class="main-title">房产公告</div>
                      <div class="bottom" v-html="homeAccounce.data[0].content"></div>
                    </div>
                  </v-card>
                </v-flex>
                <!-- <v-flex xs12>
                <v-card>
                  <div class="zone">
                    <div class="main-title">圖</div>
                  </div>
                </v-card>
              </v-flex> -->
              </v-layout>
            </v-container>
          </div>
        </div>
        <div v-if="this.is_active === '0'">
          <div class="main-title" style="color: red">风险评测未通过</div>
        </div>
        <div v-if="this.passed === 'no_pass'">
          <div class="main-title" style="color: red">投资人认证未通过</div>
        </div>
        <div v-if="this.is_active === null">
          <div class="main-title" style="color: red">请先完成风险评测</div>

        </div>
        <div v-if="this.passed === null">
          <div class="main-title" style="color: red">请先完成投资人认证</div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HomeInvest from '@/components/HomeInvest.vue'

export default {
  inject: ['reload'],
  props: {
    is_active: {
      type: String,
      default: false
    },
    passed: {
      type: String,
      default: 'no_pass'
    },
    currentTab: {
      type: String,
      default: ''
    },
    fundSum: {
      type: Number,
      default: 0
    }
  },
  components: {
    HomeInvest
  },
  data() {
    return {}
  },
  computed: mapGetters({
    fundAccounce: 'fundAccounce',
    homeAccounce: 'homeAccounce'
  }),
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$store.dispatch('getFundAccounce')
      this.$store.dispatch('getHomeAccounce')
    },
    changeTab(link) {
      this.currentTab = link
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card {
  padding: 10px;
  .zone {
    .bottom {
      margin: 8%;
    }
  }
}
a {
  color: #000000;
}
</style>
